/** 当前登录用户在 localStorage 等客户端持久化中的键后缀（租户 + 用户） */
let activeScopeSuffix = '_guest';

export function buildUserScopeSuffix(
  tenantId?: number | string | null,
  userId?: number | string | null,
): string {
  if (userId == null || userId === '') return '_guest';
  return `_t${tenantId ?? '0'}_u${userId}`;
}

export function setUserSessionScope(
  tenantId?: number | string | null,
  userId?: number | string | null,
): void {
  activeScopeSuffix = buildUserScopeSuffix(tenantId, userId);
}

export function getUserSessionScopeSuffix(): string {
  return activeScopeSuffix;
}
